import React, { useState } from 'react';
import Catalog from './Catalog';
import PackEnterprise from './PackEnterprise';
import Calendar from './Calendar';
import './Training.css';
import { set } from 'lodash';
import WhyOva from './WhyOva';
import ContactBar from './ContactBar';


const MainTrainings = () => {

    // On définit les IDs possibles pour nos onglets
    type TabId = 'catalog' | 'calendar' | 'packenterprise' | 'whyova';

    interface TabConfig {
        id: TabId;
        label: string;
        icon?: string;
        isDisabled?: boolean;
    }

    const [isActive, setIsActive] = useState(false);
    const [activeButton, setActiveButton] = useState<TabId | null>(null);

    const toggleButtonTab = (tabId: TabId) => {
        // setIsActive(!isActive);
        setActiveTab(tabId);
        setActiveButton(tabId);
    }

    const TABS: TabConfig[] = [
        { id: 'catalog', label: 'Catalogue', isDisabled: isActive },
        { id: 'calendar', label: 'Calendrier', isDisabled: isActive },
        { id: 'packenterprise', label: 'Packs Entreprise', isDisabled: isActive },
        { id: 'whyova', label: 'Pourquoi OVA ?', isDisabled: isActive},
    ];

    // Mapping entre l'ID de l'onglet et le composant à afficher
    const TAB_COMPONENTS: Record<TabId, React.FC> = {
        catalog: () => <div><Catalog /></div>,
        calendar: () => <div><Calendar /></div>,
        packenterprise: () => <div><PackEnterprise /></div>,
        whyova: () => <div><WhyOva /></div>,
    };

    // On initialise l'état avec le type TabId
    const [activeTab, setActiveTab] = React.useState<TabId>('catalog');

    // Le composant correspondant à l'onglet actif
    const ActiveContent = TAB_COMPONENTS[activeTab];


    return (
        <>
            <div className="hero">
                <div className="hero-label">OVA Consulting — Centre de formation IT</div>
                <div className="hero-title">
                    Formations professionnelles en IT, Cloud, Cybersécurité et Intelligence
                    Artificielle
                </div>
                <div className="hero-sub">
                    OVA Consulting accompagne les entreprises et les professionnels dans le
                    développement de compétences technologiques à forte valeur ajoutée — au
                    Cameroun et en Afrique centrale.
                </div>
                <div role='tablist' className="hero-btns">
                    {
                        TABS.map((tab) => (
                            <button
                                key={tab.id}
                                // className={`btn-${tab.isDisabled ? 'outline' : 'primary'} ${tab.isDisabled ? 'disabled' : ''}`}
                                className={`btn-${activeButton === tab.id ? 'primary' : 'outline'}`}
                                onClick={() => toggleButtonTab(tab.id)}
                                // disabled={tab.isDisabled}
                            >
                                {tab.icon && <i className={`fa fa-${tab.icon}`} />}
                                {tab.label}
                            </button>
                        ))
                    }

                    {/* <button
                    className="btn-primary"
                    onClick={() => window.location.href = "/trainings"}
                    >
                    Voir le catalogue
                    </button>
                    <button
                    className="btn-outline"
                    onClick={() => showTab('calendrier', document.querySelectorAll('.nav-tab')[1])}
                    >
                    Calendrier des sessions
                    </button>
                    <button
                    className="btn-outline"
                    onClick={() => openMail('Demande de devis formation','Bonjour,%0A%0AJe souhaite obtenir un devis pour une formation OVA Consulting.%0A%0AMerci.')}>
                    Demander un devis
                    </button> */}
                </div>
            </div>
            <div className="stats-row mt-4">
                <div className="stat">
                    <div className="stat-n">6</div>
                    <div className="stat-l">Domaines de formation</div>
                </div>
                <div className="stat">
                    <div className="stat-n">18</div>
                    <div className="stat-l">Formations au catalogue</div>
                </div>
                <div className="stat">
                    <div className="stat-n">8</div>
                    <div className="stat-l">Villes en Afrique centrale</div>
                </div>
                <div className="stat">
                    <div className="stat-n">100%</div>
                    <div className="stat-l">Cas pratiques entreprise</div>
                </div>
            </div>
            <div style={{ marginTop: '20px' }}>
                <ActiveContent />
            </div>
            <ContactBar />
        </>
    )
}

export default MainTrainings;